import script from "./ListarNiveisTurmas.vue?vue&type=script&setup=true&lang=js"
export * from "./ListarNiveisTurmas.vue?vue&type=script&setup=true&lang=js"

import "./ListarNiveisTurmas.vue?vue&type=style&index=0&id=68960b6f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68960b6f"]])

export default __exports__